import {Fragment, useState} from 'react';

import {MegaMenu} from 'primereact/megamenu';

import {ReduceTaxReportService as Service} from './ReduceTaxReportService';

import {useDataTable} from '../../../shared/hooks/DataTable';

import {Filter} from '../filter';

import {FormatDisplay} from '../../../shared/format';
import { FilterPL101 } from '../filter-PL101';
import { useTranslation } from '../../../shared/language';

export default function Pl432022Qh15() {
  const { t } = useTranslation();

  const [displayFilter, setDisplayFilter] = useState(null);

  const [requiredParams, setRequiredParams] = useState(null);

  const downloadExcel = () => {
    Service.downloadExcel(requiredParams).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-pl101-2023-qh15.xlsx`;
      link.click();
    });
  }

  // const downloadPdf = () => {
  //   Service.downloadPdf(requiredParams).then(data => {
  //     const link = document.createElement('a');
  //     link.href = window.URL.createObjectURL(new Blob([data]));
  //     link.download = `bao-cao-pl43-2022-qh15.pdf`;
  //     link.click();
  //   });
  // }

  const search = (params) => {
    setRequiredParams(params);
    setDisplayFilter(false);
  }

  const actions = [
    {label: t('common.filter'), icon: 'pi pi-fw pi-filter', className: 'iam-toolbar iam-toolbar-secondary', command: () => setDisplayFilter(true)},
    // {label: 'Xem in PDF', icon: 'pi pi-fw pi-file-pdf', className: 'iam-toolbar iam-toolbar-secondary', command: downloadPdf},
    {label: t('report.exportExcel'), icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadExcel}
  ];

  const {render: renderDataTable} = useDataTable({
    columns: [
      {field: 'productName', header: t('report.productNameWithService'), minWidth: 200},
      {
        field: 'amount', header: t('report.amountBeforeTax'), width: 160, dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData['amount'], FormatDisplay.getFractionDigits(rowData));
        }, style: {justifyContent: 'end'}
      },
      {field: 'taxRegulations', header: t('report.vatRateByRegulation'), width: 220},
      {field: 'taxDisCount', header: t('report.vatRateAfterReduction'), width: 240},
      {
        field: 'amountDiscount', header: t('report.vatReductionAmount'), width: 190, dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData['amountDiscount'], FormatDisplay.getFractionDigits(rowData));
        }, style: {justifyContent: 'end'}
      }
    ],
    indexColumnWidth: 40,
    getList(params: any): Promise<any> {
      return Service.getList(params);
    },
    requiredParams
  });

  return (
    <Fragment>
      <MegaMenu model={actions}/>
      <FilterPL101 header={t('menu.plReport')} display={displayFilter} setDisplay={setDisplayFilter} search={search}/>
      {renderDataTable()}
    </Fragment>
  );
}
